<h3 *ngIf="userForm.controls.id.value">Edit User</h3>
<h3 *ngIf="!userForm.controls.id.value">Add User</h3>

<div class="user-edit-container">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()" >

        <input formControlName="id" type="hidden">

        <mat-form-field class="user-form-field">
            <mat-label>Username</mat-label>
            <input matInput placeholder="Username" formControlName="username" required minlength="8">
            <mat-error *ngIf="userForm.controls.username.hasError('minlength')">
                Please enter username with more than 8 chars
            </mat-error>
            <mat-error *ngIf="userForm.controls.username.hasError('required')">
                username is <i>required</i>
            </mat-error>
        </mat-form-field>

        <mat-form-field class="user-form-field">
            <mat-label>Customer</mat-label>
            <mat-select formControlName="customerId" required>
                <mat-option *ngFor="let customer of customers" [value]="customer.id">
                    {{customer.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="user-form-field">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Email" formControlName="email" required email>
            <mat-error *ngIf="userForm.controls.email.hasError('email')">
                Please enter a valid email address
            </mat-error>
            <mat-error *ngIf="userForm.controls.email.hasError('required')">
                email is <i>required</i>
            </mat-error>
        </mat-form-field>

        <mat-form-field class="user-form-field">
            <mat-label>Enabled</mat-label>
            <mat-select formControlName="enabled" required>
                <mat-option [value]="true" >Enabled</mat-option>
                <mat-option [value]="false" >Disabled</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="user-form-field">
            <mat-label>Role</mat-label>
            <mat-select multiple formControlName="roles" required>
                <mat-option *ngFor="let role of roles" [value]="role">
                    {{role}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="userForm.controls.roles.hasError('roles')">
                role is <i>required</i>
            </mat-error>
        </mat-form-field>

        <button mat-raised-button color="primary" type="reset" (click)="clear()" class="editActionButton">Clear</button>
        <button mat-raised-button color="primary" type="submit" class="editActionButton" [disabled]="!userForm.valid">Save</button>

        <mat-error>
            <span *ngIf="userForm.errors?.usernameTaken">
              This username is already taken
            </span>
        </mat-error>
    </form>

    <!-- Useful during the dev

    <p>
        Form Status: {{ userForm.status }}
        Form Value: {{ userForm.value | json}}
    </p>
 -->
</div>

